export class EmployeeVisaDetail {
    Id: number = 0;
    EmployeeCode: string = '';
    Nationality: string = '';
    NameOfCountry: string = '';
    VisaCategory: string = '';
    VisaIssueDate: Date | null = null;
    VisaEndDate: Date | null = null;
    PassportNumber: string = '';
    IdentityProof: string = '';
    DrivingLicense: string = '';
    VisaType: number = 0;
    VisaTypeName: string = '';
    VisaNumber: string = '';
    VisaDuration: string = '';
}
